module.exports = "/cyber/_next/static/images/replenish-steam-bg-desktop-e913449a13cd20461a414aa39ae5f36c.jpg";